import { render, staticRenderFns } from "./DeleteDiagnostic.vue?vue&type=template&id=ef5680d4"
import script from "./DeleteDiagnostic.vue?vue&type=script&lang=js"
export * from "./DeleteDiagnostic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports